var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManagingFf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1257.41 978.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.38 339.42h352.76c10.3-1.08 16.54 5.3 16.54 15.44V580.7H415.84V354.86c0-10.14 6.24-16.53 16.54-15.44z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.77 610.49h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H410.33c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1147 270.43a62 62 0 1185.42-19.06 62.26 62.26 0 01-85.42 19.06z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1199.13 684.87a32.56 32.56 0 1144.83-10 32.67 32.67 0 01-44.83 10z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.68 821.21a32.56 32.56 0 0134.87-55 32.56 32.56 0 01-34.87 55z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.67 171.45A62 62 0 01105.1 66.64a62 62 0 01-66.44 104.8z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.7 128.38a41.3 41.3 0 1156.86-12.68 41.44 41.44 0 01-56.86 12.68z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.26 898.31a62 62 0 1185.42-19.06 62.26 62.26 0 01-85.42 19.06z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "managing-ff_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.61 488.41a54.51 54.51 0 1175-16.74 54.69 54.69 0 01-75 16.74z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "managing-ff_svg__a",
    x1: 977.73,
    y1: 363.31,
    x2: 213.65,
    y2: 611.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646a7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "managing-ff_svg__b",
    x1: 915.13,
    y1: 383.65,
    x2: 276.26,
    y2: 591.24,
    xlinkHref: "#managing-ff_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "managing-ff_svg__c",
    x1: 775.34,
    y1: 429.07,
    x2: 416.04,
    y2: 545.82,
    xlinkHref: "#managing-ff_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 595.69,
    cy: 487.45,
    r: 401.59,
    opacity: 0.4,
    fill: "url(#managing-ff_svg__a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.69,
    cy: 487.45,
    r: 335.78,
    opacity: 0.4,
    fill: "url(#managing-ff_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.69,
    cy: 487.45,
    r: 188.84,
    opacity: 0.4,
    fill: "url(#managing-ff_svg__c)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 595.69,
    cy: 487.45,
    r: 401.59,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.816
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.69,
    cy: 487.45,
    r: 335.78,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.816
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.69,
    cy: 487.45,
    r: 188.84,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.816
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 903.62,
    cy: 229.23,
    r: 10.2,
    fill: "#88929e",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.56,
    cy: 802.85,
    r: 8.16,
    fill: "#88929e",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.21,
    cy: 288.49,
    r: 7.76,
    fill: "#88929e",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.38,
    cy: 658.37,
    r: 6.94,
    fill: "#88929e",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.47 338.46h352.77c10.3-1.08 16.54 5.3 16.54 15.44v225.85H413.93V353.91c0-10.14 6.24-16.53 16.54-15.45zM380.86 609.53h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H408.42c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53z",
    fill: "#1d2135"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.38 349.42h352.76c10.3-1.08 16.54 5.3 16.54 15.44V590.7H425.84V364.86c0-10.14 6.24-16.53 16.54-15.44z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.38 339.42h352.76c10.3-1.08 16.54 5.3 16.54 15.44V580.7H415.84V354.86c0-10.14 6.24-16.53 16.54-15.44z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.77 620.49h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H420.33c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.77 610.49h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H410.33c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53zM464.93 461.29h181.96M464.93 396.34h181.96M464.93 526.02h181.96M749.57 378.42l-36.2.07a17.2 17.2 0 00-17.12 17.14h0a17.2 17.2 0 0017.18 17.08l36.2-.07a17.2 17.2 0 0017.12-17.14h0a17.2 17.2 0 00-17.18-17.08zM749.57 508.31l-36.2.07a17.2 17.2 0 00-17.12 17.14h0a17.2 17.2 0 0017.18 17.08l36.2-.07a17.2 17.2 0 0017.12-17.14h0a17.2 17.2 0 00-17.18-17.08zM749.57 443.37l-36.2.07a17.2 17.2 0 00-17.12 17.14h0a17.2 17.2 0 0017.18 17.08l36.2-.07a17.2 17.2 0 0017.12-17.14h0a17.2 17.2 0 00-17.18-17.08z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 714.64,
    cy: 525.42,
    rx: 8.9,
    ry: 8.88,
    transform: "rotate(-.11 713.088 526.764)",
    fill: "#88929e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 714.64,
    cy: 460.47,
    rx: 8.9,
    ry: 8.88,
    transform: "rotate(-.11 713.153 459.051)",
    fill: "#88929e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 714.64,
    cy: 395.53,
    rx: 8.9,
    ry: 8.88,
    transform: "rotate(-.11 713.213 396.547)",
    fill: "#88929e"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1155.41 277.52a62 62 0 1185.42-19.06 62.26 62.26 0 01-85.42 19.06z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1147 270.43a62 62 0 1185.42-19.06 62.26 62.26 0 01-85.42 19.06z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M1208.31 237.94l18.21-19-18.28-18.94M1151.62 238.05l-18.28-18.94 18.21-19M1168.42 238.35l22.08-38.63"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1207.5 692a32.56 32.56 0 1144.83-10 32.67 32.67 0 01-44.83 10z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1199.13 684.87a32.56 32.56 0 1144.83-10 32.67 32.67 0 01-44.83 10z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M1231.29 668.29l9.55-9.97-9.59-9.94M1201.54 668.35l-9.6-9.94 9.56-9.97M1210.73 668.51l11.59-20.28"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 828.31a32.56 32.56 0 1144.83-10 32.67 32.67 0 01-44.83 10z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.68 821.21a32.56 32.56 0 0134.87-55 32.56 32.56 0 01-34.87 55z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M48.83 804.64l9.56-9.98-9.59-9.93M19.08 804.7l-9.59-9.94 9.55-9.98M27.27 804.86l11.59-20.28"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 178.54a62 62 0 1185.42-19.06A62.26 62.26 0 0147 178.54z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.67 171.45A62 62 0 01105.1 66.64a62 62 0 01-66.44 104.8z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M99.94 138.96l18.21-19-18.29-18.94M43.25 139.07l-18.28-18.93 18.21-19.01M60.05 139.38l22.08-38.64"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.69,
    cy: 489.4,
    r: 488.9,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.994
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M361.41 319.69l-204.3-137.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M366.54 303.52l14.32 29.24-32.48-2.21 18.16-27.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M766.42 255.91l80.44-108.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M782.35 261.75l-29.85 13.01 3.65-32.35 26.2 19.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M857.08 365.19L1094.66 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M867.84 378.3l-32.32-3.93 19.56-26.03 12.76 29.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M878.15 559.92l273.47 80.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M878.15 576.88l-22.49-23.55 31.64-7.7-9.15 31.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M794.22 697.83l81.89 89.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M785.41 712.32l-6.99-31.8 31.04 9.85-24.05 21.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M345.6 627.38L87.68 770.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M333.53 615.45l32.56.55-16.75 27.92-15.81-28.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M309.92 469.66l-130.24-11.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M306.63 453.01l26.63 18.75-29.55 13.69 2.92-32.44z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.44,
    cy: 177.1,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.86,
    cy: 153.9,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.66,
    cy: 264,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1151.62,
    cy: 640.02,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.61,
    cy: 769.56,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.1,
    cy: 459.51,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 869.11,
    cy: 780.57,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.7 128.38a41.3 41.3 0 1156.86-12.68 41.44 41.44 0 01-56.86 12.68z",
    fill: "#1d2135"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M867.07 135.47a41.3 41.3 0 1156.86-12.68 41.44 41.44 0 01-56.86 12.68z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M858.7 128.38a41.3 41.3 0 1156.86-12.68 41.44 41.44 0 01-56.86 12.68z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M899.48 107.09l12.12-12.65-12.17-12.6M861.75 107.16l-12.17-12.6 12.12-12.65M871.6 107.37l14.7-25.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.26 898.31a62 62 0 1185.42-19.06 62.26 62.26 0 01-85.42 19.06z",
    fill: "#1d2135"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M906.63 905.4A62 62 0 11992 886.35a62.26 62.26 0 01-85.37 19.05z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M898.26 898.31a62 62 0 1185.42-19.06 62.26 62.26 0 01-85.42 19.06z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M959.53 865.82l18.21-19-18.28-18.94M902.84 865.93L884.56 847l18.21-19.01M919.64 866.23l22.08-38.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.61 488.41a54.51 54.51 0 1175-16.74 54.69 54.69 0 01-75 16.74z",
    fill: "#1d2135"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#managing-ff_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 495.5a54.51 54.51 0 1175-16.74 54.69 54.69 0 01-75 16.74z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.61 488.41a54.51 54.51 0 1175-16.74 54.69 54.69 0 01-75 16.74z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M131.44 459.99l16-16.7-16.06-16.63M81.64 460.08l-16.06-16.63 15.99-16.7M96 460.35l19.4-33.94"
  })))));
}

export default __webpack_public_path__ + "static/managing-ff.27670e3e.svg";
export { SvgManagingFf as ReactComponent };